export const OWNER = {
  sellers   : 'seller',
  merchants : 'merchant'
}

export const PRODUCT_TYPES = {
  'Seller::Product'       : 'Consignment',
  'Merchant::Product'     : 'Consignment',
  'Seller::MarketProduct' : 'Marketplace'
}